import React from "react";
import { Link } from "react-router-dom";
import DuplicateImg from "../../images/duplicate.png";
import { getImageUrl } from 'components/helpers/Helpers';

const CalenderDay = ({
  id,
  dayWorkouts,
  duplicatework,
  deleteworkoutt,
  isCopied,
  setWorkoutIdFunction,
  handleAddWorkout,
  handleViewAttachment,
  date,
  formatDate,
  workoutid,
  formateSetsinputs,
}) => {
  return (
    <div className="body">
      <div className="d-flex flex-row justify-content-start algin-items-center gap-2 mb-2">
        {isCopied && (
          <div
            className="duplicate-icon"
            onClick={() => duplicatework(id, workoutid, formatDate(date))}
          >
            <img src={DuplicateImg} alt="DuplicateImg}" />
          </div>
        )}
        <div
          className="icons"
          title="Add Workout"
          style={{ color: "tomato" }}
          onClick={() => handleAddWorkout(date)}
        >
          <i className="fas fa-plus icon"></i>
        </div>
      </div>
      {dayWorkouts.map((workout) => (
        <div key={workout.id} className="workout-container">
          <div className="icons">
            <div
              className="icon"
              title="Delete Workout"
              onClick={() => {
                deleteworkoutt(
                  workout?.id,
                  date.toLocaleString("default", {
                    weekday: "long",
                  })
                );
              }}
            >
              <i className="fa fa-trash"></i>
            </div>
            {!isCopied && (
              <div
                className="icon"
                title="Duplicate Workout"
                onClick={() => setWorkoutIdFunction(workout.id, workout?.name)}
              >
                <i className="fa fa-copy"></i>
              </div>
            )}

            <Link
              className="icon"
              title="Edit Workout"
              to={`/create-workout/${id}/${workout.id}`}
            >
              <i className="fa fa-pencil"></i>
            </Link>
          </div>
          <div className="workout-name">{workout.name}</div>

          <div className="description">{workout.desc}</div>
          <ul className="excercises">
            {workout?.exercises?.map((exercise) => (
              <li key={exercise.id}>
                <div className="title">{exercise.name}</div>
                <p className="subtitle">
                  Sets:
                  {workout?.workout_type === "AMRAP" ? (
                    <span>Max</span>
                  ) : (
                    <span>{exercise?.sets?.length}</span>
                  )}
                  {Object.entries(formateSetsinputs(exercise?.sets)).map(
                    ([fieldName, values]) => (
                      <span key={fieldName} className="valss bluee">
                        {`${fieldName}: ${values.join("/")} `}
                        <span className="bluee">{`${
                          fieldName === "WEIGHT"
                            ? "kgs"
                            : fieldName === "Distance"
                            ? "meters"
                            : fieldName === "CALORIES"
                            ? "calories"
                            : fieldName === "DURATION"
                            ? "minutes"
                            : fieldName === "REPETITIONS"
                            ? "reps"
                            : fieldName === "DISTANCE"
                            ? "meters"
                            : fieldName === "Jump Row"
                            ? "meters"
                            : ""
                        }`}</span>
                      </span>
                    )
                  )}
                </p>
              </li>
            ))}
          </ul>
          <div className="buttons">
            {workout?.workout_type && (
              <div className="tag">{workout?.workout_type}</div>
            )}
          </div>

          {workout?.attachments.length > 0 && (
            <div className="buttons my-1">
              <div
                className="tag d-flex flex-row justify-content-between align-items-center gap-2  pointer "
                title="View Attachments"
                onClick={() => handleViewAttachment(workout)}
              >
                {workout?.attachments.length} Attachments{" "}
                <i style={{ color: "green" }} className="fa fa-eye"></i>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CalenderDay;
